import { createContext, useContext } from 'react'
import { observable, action } from 'mobx'

class MapUpperBarStore {
    @observable anchorElResult: any = null
    @action setAnchorElResult = (el: any) => {
        this.anchorElResult = el
    }

    @observable anchorElNoResult: any = null
    @action setAnchorElNoResult = (el: any) => {
        this.anchorElNoResult = el
    }
}

const mapUpperBarStoreContent = createContext(new MapUpperBarStore())
const useMapUpperBarStore = () => useContext(mapUpperBarStoreContent)

export default useMapUpperBarStore